/**
 * @author Lucas Fridez <lucas@fridez.dev>
 * Lucas Fridez
 * (c) copyright 2018 Lucas Fridez
 *
 * Material Blue Palette
 */
export default {
    accentColor : "#2bbbad", //400
    darkPrimaryColor : "#00695c", //900
    dividerColor : "#BBDEFB", //100
    error: "#ef5350",
    lightPrimaryColor : "#90CAF9", //200
    primaryColor : "#1976D2", //700
    primaryText : "#212121",
    secondaryText : "#9B9B9B",
    success: "#2FCF70",
    text : "#FFFFFF",
    whiteTransparency90: "rgba(255, 255, 255, 0.9)",
    statCardFrom: "#c73131",
    statCardTo: "#e27c28"
};



// WEBPACK FOOTER //
// ./src/app/styles/ColorManager.ts